// extracted by mini-css-extract-plugin
export default {"card":"QuizQuestionCard_card__VqkfP","active":"QuizQuestionCard_active__EFhxF","checkIcon":"QuizQuestionCard_checkIcon__Ombal"};